import React from "react";
import ReactDOM from "react-dom";
import Flagship from "../../core/flagship";
import ClientAddModal from "../modals/ClientAddModal";
import { Dropdown, Button, Icon, Label } from "semantic-ui-react";
import { throttle, empty } from "../../utils/helpers";

class ClientField extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.onSearchChange = this.onSearchChange.bind(this);
    this.addNewClient = this.addNewClient.bind(this);
    this.onAddClient = this.onAddClient.bind(this);
    this.cancelAddNew = this.cancelAddNew.bind(this);
  }

  componentDidMount() {
    if (this.props.forceFocus === true && !empty(this.inputRef)) {
      // Don't want to use findDOMNode but don't currently have a choice :(
      const dropdownParent = ReactDOM.findDOMNode(this.inputRef);
      const input = dropdownParent.querySelector(".search");
      input.focus();
    }

    if (typeof this.props.setRef === "function") {
      this.props.setRef(this.inputRef);
    }
  }

  getInitialState() {
    return {
      searchResults: [],
      emptySearch: false,
      addingClient: false,
      newClientName: null
    };
  }

  searchClients(like) {
    let self = this;

    Flagship.get(
      "dropdown-search/client",
      {
        search: like,
        anyInstance: this.props.anyInstance
      },
      function(response) {
        if (response.data.success === true) {
          response.data.results.map(function(item, i) {
            let market = item.text.match(/(\([^\)]+\))/gim).slice(-1);
            item.content = (
              <span key={i}>
                {item.text.replace(market, "")}{" "}
                <span className="market">{market}</span>
              </span>
            );
            return item;
          });

          self.setState({
            searchResults: response.data.results,
            emptySearch:
              empty(response.data.results) ||
              response.data.results.length === 0,
            loading: false
          });
        } else {
          Flagship.error(
            "Could not retrieve dropdown search results for client field. Query: " +
              like,
            0,
            0
          );
        }
      },
      function(err) {
        Flagship.error("An error occurred in dropdown search: " + err, 0, 0);
      }
    );
  }

  addNewClient() {
    this.setState({
      addingClient: true
    });
  }

  onAddClient(id, link, key, name, market) {
    this.setState({
      newClientName: null,
      addingClient: false
    });

    if (typeof this.props.onAddClient === "function") {
      this.props.onAddClient(id, link, key, name, market);
    }
  }

  cancelAddNew() {
    this.setState({
      newClientName: null,
      addingClient: false
    });
  }

  onSearchChange(e, data) {
    let self = this;
    let search = this.searchClients.bind(this);

    this.setState(
      {
        loading: true
      },
      function() {
        self.timer = throttle(
          function() {
            search(data);
          },
          400,
          self.timer
        );
      }
    );
  }

  render() {
    return (
      <div>
        {!empty(this.props.label) ? (
          <Label className="single-field-label" size="large">
            {this.props.label}
            {this.props.required === "1" ||
            this.props.required === true ||
            this.props.required === 1 ? (
              <Icon
                color="red"
                size="tiny"
                className="asterisk"
                name="asterisk"
              />
            ) : null}
          </Label>
        ) : null}
        <Dropdown
          className="client-search"
          fluid
          search
          selection
          openOnFocus
          ref={input => (this.inputRef = input)}
          loading={this.state.loading}
          onChange={this.props.onChange}
          placeholder={this.props.placeholder}
          value={this.props.value}
          onSearchChange={this.onSearchChange.bind(this)}
          text={!empty(this.props.value) ? this.props.value.name : ""}
          options={this.state.searchResults}
        />

        {this.state.emptySearch === true && !this.props.disableAddNew ? (
          <Button
            className="add-new-client-btn"
            content="Add New..."
            onClick={this.addNewClient}
          />
        ) : null}

        {this.state.addingClient === true ? (
          <ClientAddModal
            open={true}
            cancelAddNew={this.cancelAddNew.bind(this)}
            recordId={this.props.recordId}
            name={this.state.newClientName}
            onAddClient={this.onAddClient}
          />
        ) : null}
      </div>
    );
  }
}

export default ClientField;



// WEBPACK FOOTER //
// ./src/components/misc/ClientField.js